import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { EditAuditPictureItemDialogComponent } from '../edit-audit-picture-item-dialog/edit-audit-picture-item-dialog.component';

@Component({
  selector: 'vr-preview-audit-picture-dialog',
  templateUrl: './preview-audit-picture-dialog.component.html',
  styleUrls: ['./preview-audit-picture-dialog.component.scss']
})
export class PreviewAuditPictureDialogComponent {
  audit: any;
  file_url: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<PreviewAuditPictureDialogComponent>,
    private dialog: MatDialog,
    private changeDetectorRefs: ChangeDetectorRef
  ) {
    this.audit = data.audit;
    this.file_url = data.file_url;
  }

  close() {
    this.dialogRef.close();
  }

  parseDate(dateStr: string): Date | null {
    if (!dateStr) return null;
    const date = new Date(dateStr.replace(' ', 'T'));
    return isNaN(date.getTime()) ? null : date;
  }

  getGroupLetter(index: number): string {
    return String.fromCharCode(65 + index);
  }

  getTotalAnomalies(): number {
    if (!this.audit || !this.audit.audit_item_groups) return 0;
    return this.audit.audit_item_groups.reduce((sum: number, g: any) => sum + (g.audit_items ? g.audit_items.length : 0), 0);
  }

  editItem(item: any, gIdx: number, iIdx: number) {
    this.dialog.open(EditAuditPictureItemDialogComponent, {
      height: '90vh',
      width: '90vw',
      maxWidth: '90vw',
      data: { item: item, audit_id: this.audit.id }
    } as MatDialogConfig).afterClosed().subscribe((result) => {
      if (result && result['saved']) {
        this.audit.audit_item_groups[gIdx].audit_items[iIdx] = result['item'];
        this.changeDetectorRefs.detectChanges();
      }
    });
  }
}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/dialogs/preview-audit-picture-dialog/preview-audit-picture-dialog.component.ts